import type { EventContext } from '../../../types';

import {
  getItemSku,
  getDiscount,
  getItemCategory,
  getItemCategory2,
  getItemCategory4,
  getItemShippingTier,
  normalizeBrand,
} from '../../utils';

/**
 * Builds an array of normalized item objects from the order form contained in the given context.
 *
 * @param context - EventContext containing an orderForm with items to convert
 * @returns An array of item-like objects derived from `context.orderForm.items`, each containing fields such as `item_id`, `price`, `quantity`, `item_sku`, `item_name`, category and variant attributes, and `discount`
 */
export async function itemsFromOrderForm(context: EventContext) {
  const items = context.orderForm?.items || [];

  if (!items.length) return [];

  return await Promise.all(
    items.map(async (item: EventContext) => ({
      item_id: item.productId,
      item_category2: getItemCategory2(item),
      item_category4: getItemCategory4(item),
      item_shipping_tier: getItemShippingTier(context.orderForm, item),
      price: parseFloat((item.price / 100).toFixed(2)) || 0,
      quantity: item.quantity || 1,
      item_ref: item.refId || null,
      item_brand: normalizeBrand(item.additionalInfo?.brandName) || item.additionalInfo?.brandName || null,
      item_sku: (await getItemSku(item)) || item.id || null,
      item_name: item.name.split(' - ').shift() || item.id || null,
      item_category: getItemCategory(item) || null,
      item_variant: item.skuName.split(/[-/]/)[0].trim(),
      item_variant2: item.skuName.split(/[-/]/).pop()?.trim() || '',
      discount: getDiscount(item),
    }))
  );
}
